/**
 * Lumina — apparition des sections et des grilles au défilement.
 *
 * Activé par Paramètres du thème > Lumina > Animations (classe `lumina-reveal-enabled` sur <body>).
 * N'agit que sur les éléments situés sous la ligne de flottaison au chargement, pour ne jamais
 * masquer du contenu déjà visible. Désactivé dans l'éditeur et si l'utilisateur préfère moins
 * d'animations.
 */
(() => {
  const body = document.body;
  if (!body || !body.classList.contains('lumina-reveal-enabled')) return;
  if (document.documentElement.classList.contains('shopify-design-mode')) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  const main = document.getElementById('MainContent');
  if (!main) return;

  const staggerEnabled = body.classList.contains('lumina-stagger-enabled');
  const EXCLUDED = '.product-information, product-information, cart-items-component, .main-collection-grid, age-verification';
  const GROUPS = '.product-grid, .resource-list, [data-lumina-stagger]';
  const FOLD = window.innerHeight * 0.92;
  const CLEANUP_DELAY = 1800;

  const isBelowFold = (element) => element.getBoundingClientRect().top > FOLD;

  const cleanup = (element) => {
    window.setTimeout(() => {
      element.classList.remove('lumina-reveal', 'lumina-reveal-group', 'is-revealed');
      for (const item of element.querySelectorAll(':scope > .lumina-reveal-item')) {
        item.classList.remove('lumina-reveal-item');
        item.style.removeProperty('--lumina-reveal-delay');
      }
    }, CLEANUP_DELAY);
  };

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
        cleanup(entry.target);
      }
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.01 }
  );

  for (const section of main.querySelectorAll(':scope > .shopify-section')) {
    if (section.querySelector(EXCLUDED) || !isBelowFold(section)) continue;
    section.classList.add('lumina-reveal');
    observer.observe(section);
  }

  if (staggerEnabled) {
    for (const group of main.querySelectorAll(GROUPS)) {
      if (group.closest(EXCLUDED) || group.parentElement?.closest('.lumina-reveal-group')) continue;
      if (!isBelowFold(group)) continue;

      const items = Array.from(group.children).filter((child) => child instanceof HTMLElement);
      if (items.length < 2) continue;

      group.classList.add('lumina-reveal-group');
      items.forEach((item, index) => {
        item.classList.add('lumina-reveal-item');
        item.style.setProperty('--lumina-reveal-delay', `${Math.min(index, 8) * 70}ms`);
      });
      observer.observe(group);
    }
  }
})();
